import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "general__reply",
  "use": "general__reply-usage",
  "viewBox": "0 0 15 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 15 14\" id=\"general__reply\">\n  <path d=\"M12.274 1H2.726C1.7749 1 1 1.7932 1 2.7761v5.9734c0 .983.7749 1.7762 1.726 1.7762h2.9782l1.3735 2.2352c.0918.148.246.2391.415.2391.1689 0 .3231-.091.415-.239l1.3734-2.2353h2.993c.951 0 1.7259-.7932 1.7259-1.7762V2.7761C14 1.7931 13.2252 1 12.274 1z\" fill=\"transparent\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol